export default {
      id: "ic-vaix-search-close-btn-usage",
      viewBox: "0 0 18 18",
      url: "/" + "images/icons.3.109.2.svg#ic-vaix-search-close-btn-usage",
      toString: function () {
        return this.url;
      }
    }